import Api from './api';

const ObrasService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/obras/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/obras/buscar?${params}`)
        return response
    }
}

export default ObrasService;